__turbopack_context__.v({
  "teamIcon": "team-icon-module-sass-module__mfSn1q__teamIcon",
});
